import { AxiosPromise } from 'axios';

import { ApiService } from 'app/services/api.service';

export const PhoneNumbersService = {
  validate(number: string): AxiosPromise<boolean> {
    return ApiService.get('phone-numbers/validate', {
      params: { number },
    }) as AxiosPromise<boolean>;
  },
};
